module.exports = __webpack_public_path__ + "static/media/email-icon.f1269b0b.svg";